/**
 * ALTIORA · Quick actions catalogue (Command Palette).
 *
 * Actions rapides accessibles via ⌘K en plus des routes de NAV_ITEMS.
 * Chaque action a une permission requise (filtrée par la palette selon
 * les droits de l'utilisateur), un handler `run(nav)` et une catégorie.
 */
export const QUICK_ACTIONS = [
  // ── Création rapide ─────────────────────────────────────────────
  {
    id: "create-dossier",
    label: "Créer un nouveau dossier client",
    hint: "Ouvre Studio Clients avec un formulaire vide",
    perm: "pro.view_own_dashboard",
    kind: "create",
    run: (nav) => nav("/app/pro/clients?new=1"),
  },
  {
    id: "create-alert",
    label: "Créer une alerte de veille",
    hint: "Nouvelle alerte périodique (secteur, mot-clé, territoire)",
    perm: "self.view_dashboard",
    kind: "create",
    run: (nav) => nav("/app/alerts?new=1"),
  },
  {
    id: "create-opp",
    label: "Ajouter une opportunité (Opportunity Inbox)",
    hint: "Voix, image ou texte — IA extraction",
    perm: "pro.view_own_dashboard",
    kind: "create",
    run: (nav) => nav("/app/intelligence-commerciale?tab=inbox"),
  },
  {
    id: "generate-bilan",
    label: "Générer un bilan exécutif PDF",
    hint: "Rapport client personnalisé (Claude 4.5)",
    perm: "pro.view_own_dashboard",
    kind: "create",
    run: (nav) => nav("/app/pro/clients?generate=bilan"),
  },
  {
    id: "wizard-country",
    label: "Ajouter un pays au navigateur (wizard sans-code)",
    hint: "Nouveau registre public en 3 étapes",
    perm: "founder.system_settings",
    kind: "create",
    run: (nav) => nav("/app/navigateur?tab=registries&wizard=1"),
  },
  // ── Vues rapides ────────────────────────────────────────────────
  {
    id: "view-analytics",
    label: "Voir les analytics du Navigateur",
    hint: "Registres, Impact, Digest Copilote",
    perm: "self.view_dashboard",
    kind: "view",
    run: (nav) => nav("/app/navigateur?tab=analytics"),
  },
  {
    id: "view-design-system",
    label: "Ouvrir la bibliothèque Design System",
    hint: "Tokens, primitives, motion",
    perm: null,
    kind: "view",
    run: (nav) => nav("/app/design-system"),
  },
  {
    id: "view-passport",
    label: "Ouvrir mon passeport ABI",
    hint: "Signature institutionnelle personnelle",
    perm: "pro.view_own_dashboard",
    kind: "view",
    run: (nav) => nav("/app/abi/passport"),
  },
  // ── Actions admin ───────────────────────────────────────────────
  {
    id: "admin-approve-partners",
    label: "Approuver / gérer les partenaires",
    hint: "Répertoire fondateur",
    perm: "founder.view_all_partners",
    kind: "admin",
    run: (nav) => nav("/app/partner-directory"),
  },
  {
    id: "admin-users",
    label: "Gérer les utilisateurs",
    hint: "Console d'administration",
    perm: "admin.manage_members",
    kind: "admin",
    run: (nav) => nav("/app/admin/users"),
  },
];

export const KIND_LABEL = {
  create: "Créer",
  view:   "Ouvrir",
  admin:  "Admin",
};
